import * as Location from "expo-location";
import { Platform } from "react-native";
import { SelectedAddressType } from "../types/EditProfileScreen";

const DEFAULT_LOCATION: SelectedAddressType = {
  name: "Chalakudy",
  location: { latitude: "10.304904609193555", longitude: "76.3348593139167" },
  description: "Mise811 Chalakudy",
};

const fetchLocation = async (lastKnown = true, cb = () => {}) => {
  return new Promise((resolve, reject) => {
    (async () => {
      let { status } = await Location.requestForegroundPermissionsAsync();
      if (status !== "granted") {
        cb();
        resolve({
          coords: {
            latitude: parseFloat(DEFAULT_LOCATION.location.latitude),
            longitude: parseFloat(DEFAULT_LOCATION.location.longitude),
          },
        } as Location.LocationObject);
        return;
      }
      if (lastKnown && Platform.OS !== "web") {
        let lastKnownLocation = await Location.getLastKnownPositionAsync();
        resolve(lastKnownLocation as Location.LocationObject);
        return;
      }
      let location = await Location.getCurrentPositionAsync({
        accuracy: Location.Accuracy.Balanced,
      });
      resolve(location as Location.LocationObject);
    })();
  });
};

export { fetchLocation, DEFAULT_LOCATION };
